//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import * as Config from "eai-configurator-ui/components/configuration/utils/ConfigurationRegistry";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
export var convertConfigDataToTableData = function convertConfigDataToTableData(path, columns) {
  var config = Config.fromPath(path);
  return config ? config.children.map(function (child, dataIndex) {
    var row = {};
    columns.forEach(function (column) {
      var key = column.dataField;
      var value = "";
      if (key) {
        if (key === "dataIndex") {
          value = dataIndex;
        } else {
          var grandchild = Config.getChild(child, column.dataField, true);
          if (grandchild) {
            value = grandchild.data.value == null ? "" : grandchild.data.value;
          }
        }
      }
      row[key] = value;
    });
    return row;
  }) : [];
};